/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export default function createCanvasManager({ canvasId = 'sprayCanvas' } = {}) {
  const canvas = document.getElementById(canvasId);
  if (!canvas) {
    return {
      canvas: null,
      ctx: null,
      activeCtx: null,
      setPreviewTarget: () => { },
      getCanvasCoords: () => ({ x: 0, y: 0 }),
      clear: () => { },
      isAvailable: () => false
    };
  }
  const ctx = canvas.getContext('2d');
  function getCanvasCoords(e) {
    const rect = canvas.getBoundingClientRect();
    let clientX, clientY;
    if (e.touches && e.touches.length > 0) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY
    };
  }
  function clear(fillColor = '#000') {
    if (!ctx || !canvas) return;
    const previousFillStyle = ctx.fillStyle;
    ctx.fillStyle = fillColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = previousFillStyle;
  }
  function isAvailable() {
    return !!canvas && !!ctx;
  }
  function getSize() {
    if (!canvas) return { width: 0, height: 0 };
    return {
      width: canvas.width,
      height: canvas.height
    };
  }
  function setSize(width, height) {
    if (!canvas) return;
    const imageData = ctx ? ctx.getImageData(0, 0, canvas.width, canvas.height) : null;
    canvas.width = width;
    canvas.height = height;
    if (ctx && imageData) {
      ctx.putImageData(imageData, 0, 0);
    }
  }
  let _previewCtx = null;
  function setPreviewTarget(previewCtx) {
    _previewCtx = previewCtx || null;
  }
  function getActiveCtx() {
    return _previewCtx || ctx;
  }
  return {
    canvas,
    ctx,
    get activeCtx() { return getActiveCtx(); },
    setPreviewTarget,
    getCanvasCoords,
    clear,
    isAvailable,
    getSize,
    setSize
  };
}